export default {
  opponentRank: {
    title: "Ranking avversario",
    tabs: {
      byRanking: "Per ranking",
      allRankings: "Tutti i ranking",
    },
    empty: {
      title: "Nessun ranking avversario disponibile",
    },
  },
};